import React from "react";
import Header from "../components/common/Header/Header";
import { Outlet } from "react-router-dom";
import Footer from "../components/Home/Footer";
import { useAxiosInterceptors } from "../services/api";

const Layout = () => {
	useAxiosInterceptors();
	return (
		<div className="overflow-x-hidden">
			<div>
				<div>
					<Header />
				</div>
				<Outlet />
			</div>
			<Footer />
		</div>
	);
};

export default Layout;
